/**
 * The sidebar Conversations badge rules (GLOBAL_CONVERSATIONS_SLICE2_SPEC.md §5.1, §6.2, §8; D44, NAV): hidden at 0,
 * the number for 1-99, "99+" above, and the aria-label with the real count. The template binds the view model only
 * (`badge.visible`, `badge.text`, `badge.ariaLabel`), so the old `99+` template logic disappears (STANDARDS §1.5).
 * Pure: `ConversationCountsStore.badge$` maps the server's `NavBadgeCount` through `toBadgeVm`.
 */
import { badgeAria, badgeText } from './conversation-copy';

/** What the sidebar item draws for its badge (the expanded count and the slim dot share `visible`). */
export interface ConversationBadgeVm {
    /** False at 0 and for an unknown count: no badge element, no dot, never a "0". */
    visible: boolean;
    /** "1".."99", or "99+" above 99; '' when hidden. */
    text: string;
    /** "‹N› conversations need your attention" with the real count; '' when hidden. */
    ariaLabel: string;
}

/**
 * The badge for a count: hidden for null, undefined, NaN and anything ≤ 0; otherwise the whole count, capped at "99+"
 * for the text, with the real count in the aria-label.
 */
export function toBadgeVm(count: number | null | undefined): ConversationBadgeVm {
    const value = typeof count === 'number' && isFinite(count) ? Math.floor(count) : 0;

    if (value <= 0) {
        return { visible: false, text: '', ariaLabel: '' };
    }
    return { visible: true, text: badgeText(value), ariaLabel: badgeAria(value) };
}
